import { getServerTime, dictionaryList } from '@/api/api'

/**
 * 获取年度报告时间配置
 * @returns {Promise<{startDate: Date|null, endDate: Date|null}>}
 */
async function fetchAnnualReportConfig() {
  try {
    const { code, data } = await dictionaryList({
      typeCode: 'ANNUAL_REPORT_TIME_TYPE',
      dataStatus: '1'
    })

    if (code !== 0 || !data || !data.length) {
      return { startDate: null, endDate: null }
    }

    let config
    try {
      config = JSON.parse(data[0].explainContent)
    } catch (e) {
      return { startDate: null, endDate: null }
    }

    const { startTime, endTime } = config
    if (!startTime || !endTime) {
      return { startDate: null, endDate: null }
    }

    // 构造 Date 对象
    const reportStartDate = new Date(`${startTime} 00:00:00`)
    const reportEndDate = new Date(`${endTime} 23:59:59`)

    return {
      startDate: reportStartDate,
      endDate: reportEndDate
    }
  } catch (error) {
    console.error('获取年度报告时间配置失败:', error)
    return { startDate: null, endDate: null }
  }
}

export async function isAnnualReportLive(serverTime) {
  try {
    // 1. 获取服务器时间
    let currentDate
    if (serverTime) {
      currentDate = new Date(serverTime)
    } else {
      const time = await getServerTime()
      if (!time) {
        return false
      }
      currentDate = new Date(time)
    }

    // 2. 获取年度报告时间配置
    const { startDate, endDate } = await fetchAnnualReportConfig()

    if (!startDate || !endDate) {
      return false
    }

    // 3. 时间判断
    return currentDate >= startDate && currentDate <= endDate
  } catch (error) {
    console.error('获取年度报告时间配置失败:', error)
    return false
  }
}

/**
 * 获取年度报告的开始和结束日期
 * @returns {Promise<{startDate: Date|null, endDate: Date|null}>}
 */
export async function getAnnualReportDates() {
  return fetchAnnualReportConfig()
}



// WEBPACK FOOTER //
// ./src/utils/annualReport.js